import React, { useState } from "react";
import { useAuth } from "./AuthContext";
import { useNavigate } from "react-router-dom";
import { Stack, TextField, Button } from "@mui/material";
import AuthShell from "./AuthShell";

const ForgotPasswordForm = () => {
  const [email, setEmail] = useState("");
  const [isEmailSent, setIsEmailSent] = useState(false);
  const { sendPasswordReset } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const result = await sendPasswordReset(email);

      if (result === "success") {
        setIsEmailSent(true);
      } else {
        console.error(
          "Failed to send password reset email due to technical issue"
        );
      }
    } catch (err) {
      console.error(err);
    }
  };

  if (isEmailSent) {
    return (
      <AuthShell title="Check your email">
        <div className="auth-success-icon">✓</div>
        <p className="auth-sub">
          Please check <strong style={{ color: "var(--text)" }}>{email}</strong>{" "}
          for instructions on how to reset your password.
        </p>
        <button
          type="button"
          className="auth-back"
          onClick={() => navigate("/signin")}
        >
          ← Back to sign in
        </button>
      </AuthShell>
    );
  }

  return (
    <AuthShell
      title="Reset your password"
      subtitle="Enter your email address and we'll send you instructions to reset your password."
    >
      <form onSubmit={handleSubmit} className="auth-form">
        <Stack spacing={2}>
          <TextField
            size="small"
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            fullWidth
          />
          <Button variant="contained" type="submit">
            Continue
          </Button>
        </Stack>
      </form>
      <button
        type="button"
        className="auth-back"
        onClick={() => navigate("/signin")}
      >
        ← Back to sign in
      </button>
    </AuthShell>
  );
};

export default ForgotPasswordForm;
